import Props from "./props";
import styled from "styled-components";

const StyledInput = styled.input<Props>`
    outline: none;
    border: none;
    line-height: 2rem;
    width: 100%;
    & + span {
        height: 2px;
        display: block;
        width: 100%;
        position: relative;
        &:before,
        &:after {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
        }
        &:before {
            background-color: ${props => props.theme.colors.black(0.1)};
            width: 100%;
        }
        &:after {
            background-color: ${props => props.theme.colors.primary(1)};
            width: 0%;
            transition: width 0.6s ease;
        }
    }
    &:focus + span {
        &:after {
            width: 100%;
        }
    }
`;

export default StyledInput;
